import { ClubPost, ClubTag, isPromo } from '@alliance/clubs/domain'
import { ImageAttributesHelperService } from '@alliance/clubs/utils'
import { ImageAttributesType, RxStateComponent } from '@alliance/shared/models'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { filter, map } from 'rxjs/operators'

@Component({
  template: '',
  styleUrls: ['./card.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseCardComponent extends RxStateComponent<{
  post: ClubPost | null
  withImg: boolean
  withRubrics: boolean
  titleClasses: string
  imageAttributes: ImageAttributesType
}> {
  public constructor(private imageAttributesHelperService: ImageAttributesHelperService) {
    super()

    this.initState({
      post: null,
      withImg: true,
      withRubrics: true,
      titleClasses: 'santa-typo-regular-bold',
      imageAttributes: this.select('post').pipe(
        filter(Boolean),
        map(data => this.imageAttributesHelperService.getPostImageAttributes(data.title))
      )
    })
  }

  @Input()
  public set post(value: ClubPost) {
    this.set({ post: value })
  }
  @Input()
  public set withImg(value: boolean) {
    this.set({ withImg: value })
  }
  @Input()
  public set withRubrics(value: boolean) {
    this.set({ withRubrics: value })
  }
  @Input()
  public set titleClasses(value: string) {
    this.set({ titleClasses: value })
  }

  public isPromo(tags: ClubTag[]): boolean {
    return isPromo(tags)
  }
}
